import isPropValid from '@emotion/is-prop-valid';
import type { ReactElement } from 'react';
import { StyleSheetManager as SCStyleSheetManager } from 'styled-components';

import { IS_PRERENDER } from '#src/config.ts';

function shouldForwardProp(propName: string, target: any) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}

type Props = {
  children: ReactElement;
  /** Inject into another document, e.g. a picture-in-picture window head. */
  target?: HTMLElement;
};

export const StyleSheetManager = ({ children, target }: Props) => {
  return (
    <SCStyleSheetManager
      disableCSSOMInjection={IS_PRERENDER}
      enableVendorPrefixes
      shouldForwardProp={shouldForwardProp}
      target={target}
    >
      {children}
    </SCStyleSheetManager>
  );
};
